// extracted by css-extract-rspack-plugin
export default {"cls1":"ReportList-cls1_xA9","cls2":"ReportList-cls2_Mkq ReportList-cls1_xA9"};